import side from './side/index.js'
import picker from './picker/index.js'
import popup from './popup/index.js'
import * as tool from './tool/index.js'

app.x3 = {
    picker,
    popup,
    tool,
    side
}